import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const GET_INTRASTAT_LIST_START = "GET_INTRASTAT_LIST_START";
export const GET_INTRASTAT_LIST_SUCCESS = "GET_INTRASTAT_LIST_SUCCESS";
export const GET_INTRASTAT_LIST_ERROR = "GET_INTRASTAT_LIST_ERROR";

export const CREATE_NOMENCLATURE_START = "CREATE_NOMENCLATURE_START";
export const CREATE_NOMENCLATURE_SUCCESS = "CREATE_NOMENCLATURE_SUCCESS";
export const CREATE_NOMENCLATURE_ERROR = "CREATE_NOMENCLATURE_ERROR";

export const UPDATE_NOMENCLATURE_START = "UPDATE_NOMENCLATURE_START";
export const UPDATE_NOMENCLATURE_SUCCESS = "UPDATE_NOMENCLATURE_SUCCESS";
export const UPDATE_NOMENCLATURE_ERROR = "UPDATE_NOMENCLATURE_ERROR";

export const DELETE_NOMENCLATURE_START = "DELETE_NOMENCLATURE_START";
export const DELETE_NOMENCLATURE_SUCCESS = "DELETE_NOMENCLATURE_SUCCESS";
export const DELETE_NOMENCLATURE_ERROR = "DELETE_NOMENCLATURE_ERROR";

export const UPDATE_DRAWER_FIELDS_START = "UPDATE_DRAWER_FIELDS_START";
export const UPDATE_DRAWER_FIELDS_SUCCESS = "UPDATE_DRAWER_FIELDS_SUCCESS";
export const UPDATE_DRAWER_FIELDS_ERROR = "UPDATE_DRAWER_FIELDS_ERROR";

export const GET_TRANSACTION_A_LIST_START = "GET_TRANSACTION_A_LIST_START";
export const GET_TRANSACTION_A_LIST_SUCCESS = "GET_TRANSACTION_A_LIST_SUCCESS";
export const GET_TRANSACTION_A_LIST_ERROR = "GET_TRANSACTION_A_LIST_ERROR";

export const GET_TRANSACTION_B_LIST_START = "GET_TRANSACTION_B_LIST_START";
export const GET_TRANSACTION_B_LIST_SUCCESS = "GET_TRANSACTION_B_LIST_SUCCESS";
export const GET_TRANSACTION_B_LIST_ERROR = "GET_TRANSACTION_B_LIST_ERROR";

export const GET_DELIVERY_TERMS_LIST_START = "GET_DELIVERY_TERMS_LIST_START";
export const GET_DELIVERY_TERMS_LIST_SUCCESS = "GET_DELIVERY_TERMS_LIST_SUCCESS";
export const GET_DELIVERY_TERMS_LIST_ERROR = "GET_DELIVERY_TERMS_LIST_ERROR";

export const GET_DELIVERY_MODE_LIST_START = "GET_DELIVERY_MODE_LIST_START";
export const GET_DELIVERY_MODE_LIST_SUCCESS = "GET_DELIVERY_MODE_LIST_SUCCESS";
export const GET_DELIVERY_MODE_LIST_ERROR = "GET_DELIVERY_MODE_LIST_ERROR";

export const GET_COUNTRIES_LIST_START = "GET_COUNTRIES_LIST_START";
export const GET_COUNTRIES_LIST_SUCCESS = "GET_COUNTRIES_LIST_SUCCESS";
export const GET_COUNTRIES_LIST_ERROR = "GET_COUNTRIES_LIST_ERROR";

export const GET_DELIVERY_METHOD_LIST_START = "GET_DELIVERY_METHOD_LIST_START";
export const GET_DELIVERY_METHOD_LIST_SUCCESS = "GET_DELIVERY_METHOD_LIST_SUCCESS";
export const GET_DELIVERY_METHOD_LIST_ERROR = "GET_DELIVERY_METHOD_LIST_ERROR";

export const GET_COLLECTION_MODES_LIST_START = "GET_COLLECTION_MODES_LIST_START";
export const GET_COLLECTION_MODES_LIST_SUCCESS = "GET_COLLECTION_MODES_LIST_SUCCESS";
export const GET_COLLECTION_MODES_LIST_ERROR = "GET_COLLECTION_MODES_LIST_ERROR";

export const GET_CUSTOM_CODES_LIST_START = "GET_CUSTOM_CODES_LIST_START";
export const GET_CUSTOM_CODES_LIST_SUCCESS = "GET_CUSTOM_CODES_LIST_SUCCESS";
export const GET_CUSTOM_CODES_LIST_ERROR = "GET_CUSTOM_CODES_LIST_ERROR";

export function getIntrastatList(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/intrastat?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_INTRASTAT_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_INTRASTAT_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_INTRASTAT_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_INTRASTAT_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function createNomenclature(draftId, nomenclature) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/intrastat/nomenclature?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: nomenclature
      };

      dispatch({
        type: CREATE_NOMENCLATURE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: CREATE_NOMENCLATURE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: CREATE_NOMENCLATURE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: CREATE_NOMENCLATURE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function updateNomenclature(
  draftId, nomenclatureId, fieldTochange
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/intrastat/nomenclature/${nomenclatureId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: fieldTochange
      };

      dispatch({
        type: UPDATE_NOMENCLATURE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: UPDATE_NOMENCLATURE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: UPDATE_NOMENCLATURE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: UPDATE_NOMENCLATURE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function deleteNomenclature(draftId, nomenclatureId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/intrastat/nomenclature/${nomenclatureId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: DELETE_NOMENCLATURE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: DELETE_NOMENCLATURE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: DELETE_NOMENCLATURE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: DELETE_NOMENCLATURE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function updateDrawerFields(
  draftId, nomenclatureId, fieldTochange
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/intrastat/nomenclature/${nomenclatureId}/model?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: fieldTochange
      };

      dispatch({
        type: UPDATE_DRAWER_FIELDS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: UPDATE_DRAWER_FIELDS_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: UPDATE_DRAWER_FIELDS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: UPDATE_DRAWER_FIELDS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getTransactionAList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/transactions-code-a`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_TRANSACTION_A_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_TRANSACTION_A_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_TRANSACTION_A_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_TRANSACTION_A_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getTransactionBList(codeA) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/transactions-code-b?codeA=${codeA}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_TRANSACTION_B_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_TRANSACTION_B_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_TRANSACTION_B_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_TRANSACTION_B_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getDeliveryTermsList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/delivery-terms`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_DELIVERY_TERMS_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_DELIVERY_TERMS_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_DELIVERY_TERMS_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_DELIVERY_TERMS_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getDeliveyModeList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/delivery-mode`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_DELIVERY_MODE_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_DELIVERY_MODE_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_DELIVERY_MODE_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_DELIVERY_MODE_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getCountriesList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/countries`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_COUNTRIES_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_COUNTRIES_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_COUNTRIES_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_COUNTRIES_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getDeliveyMethodList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/delivery-method`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_DELIVERY_METHOD_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_DELIVERY_METHOD_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_DELIVERY_METHOD_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_DELIVERY_METHOD_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getCollectionModesList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/collection-modes`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_COLLECTION_MODES_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_COLLECTION_MODES_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_COLLECTION_MODES_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_COLLECTION_MODES_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getCustomCodesList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/intrastat/customs`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: GET_CUSTOM_CODES_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_CUSTOM_CODES_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_CUSTOM_CODES_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_CUSTOM_CODES_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
